var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollab13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 324.7 72.8",
    style: {
      enableBackground: "new 0 0 324.7 72.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F26122;}\r\n\t.st1{fill:#1173B3;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F26122;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#1173B3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,22.5l-1.1-3H5.5l-1.1,3H0l6.9-18h4.8l6.9,18H14.3z M9.3,8.3l-2.8,7.7h5.6L9.3,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,22.5v-18h3.8v14.6h7.6v3.4H20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.3,22.5v-18h3.8v14.6h7.6v3.4H33.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.6,22.5v-18h3.8v18H46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66,22.5l-1.1-3h-7.7l-1.1,3h-4.4l6.9-18h4.8l6.9,18H66z M61.1,8.3l-2.8,7.7h5.6L61.1,8.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.2,22.5l-8.6-11.7v11.7h-3.8v-18h3.9L84,15.8V4.5h3.8v18H84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.3,13.5c0-5.5,4.2-9.3,9.6-9.3c4,0,6.2,2.2,7.5,4.4l-3.3,1.6c-0.8-1.5-2.4-2.6-4.2-2.6 c-3.3,0-5.6,2.5-5.6,5.9c0,3.4,2.4,5.9,5.6,5.9c1.9,0,3.5-1.1,4.2-2.6l3.3,1.6c-1.3,2.2-3.6,4.4-7.5,4.4 C94.4,22.8,90.3,19,90.3,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.3,22.5v-18H122v3.4h-8.9v3.8h8.7V15h-8.7v4.1h8.9v3.4H109.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.4,22.5v-18h11.4v1.4h-9.9v6.6h9.7V14h-9.7v8.5H139.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M153.1,13.5c0-5.2,3.4-9.3,8.7-9.3c5.2,0,8.7,4,8.7,9.3c0,5.2-3.5,9.3-8.7,9.3 C156.5,22.8,153.1,18.8,153.1,13.5z M168.9,13.5c0-4.6-2.8-7.9-7.1-7.9c-4.4,0-7.1,3.3-7.1,7.9c0,4.5,2.7,7.9,7.1,7.9 C166.1,21.4,168.9,18,168.9,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.6,22.5l-5-7.4h-4v7.4H174v-18h6.7c3.1,0,5.5,2,5.5,5.2c0,3.3-2.3,5.1-5,5.2l5.2,7.5H184.6z M184.6,9.8 c0-2.3-1.6-3.8-4-3.8h-5v7.7h5C183,13.6,184.6,12,184.6,9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.5,43.3l2.4-3.6C4.2,41,6.2,42,8.7,42c1.6,0,2.5-0.5,2.5-1.4c0-2.4-10.1-0.4-10.1-7.3c0-3,2.5-5.7,7.1-5.7 c2.9,0,5.4,0.9,7.3,2.5l-2.5,3.5c-1.5-1.3-3.5-1.9-5.2-1.9c-1.3,0-1.9,0.5-1.9,1.2c0,2.2,10.1,0.5,10.1,7.2c0,3.6-2.7,6-7.5,6 C4.8,46.1,2.3,45,0.5,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.8,45.8l-0.9-2.6h-7.1l-0.9,2.6h-5.2l6.8-18h5.8l6.8,18H29.8z M25.3,32.4l-2.3,6.8h4.5L25.3,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.1,45.8v-18h13.2v4h-8.5v2.8H49v4h-8.3v7.1H36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.5,45.8v-18h13.2v4h-8.5v2.8h8.3v4h-8.3v3h8.5v4H51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.9,45.8V31.9h-5v-4h14.7v4h-5v13.9H70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.9,45.8v-7.2l-6.8-10.7h5.2l3.9,6.6l3.8-6.6h5.2l-6.8,10.7v7.2H87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.2,45.8l-1.8-4.4H110l-1.8,4.4h-1.8l7.3-18h1.9l7.3,18H121.2z M114.7,29.5L110.5,40h8.5L114.7,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.3,45.8L127,30.4v15.4h-1.5v-18h1.6l11.3,15.2V27.8h1.5v18H138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.2,45.8v-18h5.7c5.6,0,9.1,4.1,9.1,9c0,5-3.5,9-9.1,9H144.2z M157.4,36.8c0-4.2-2.7-7.6-7.5-7.6h-4.2 v15.2h4.2C154.6,44.4,157.4,41,157.4,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.6,44.5l1.9-3.5c0.6,0.5,1.5,1,2.6,1c1.5,0,2.4-0.9,2.4-2.4V27.8h4.6v11.8c0,4.4-2.7,6.5-6.6,6.5 C170.7,46.1,169,45.7,167.6,44.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.1,38.5V27.8h4.7v10.5c0,2.1,1.3,3.7,3.8,3.7c2.5,0,3.8-1.5,3.8-3.7V27.8h4.7v10.7c0,4.5-2.7,7.6-8.5,7.6 C184.8,46.1,182.1,42.9,182.1,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200.6,43.3l2.4-3.6c1.3,1.3,3.3,2.4,5.8,2.4c1.6,0,2.5-0.5,2.5-1.4c0-2.4-10.1-0.4-10.1-7.3 c0-3,2.5-5.7,7.1-5.7c2.9,0,5.4,0.9,7.3,2.5l-2.5,3.5c-1.5-1.3-3.5-1.9-5.2-1.9c-1.3,0-1.9,0.5-1.9,1.2c0,2.2,10.1,0.5,10.1,7.2 c0,3.6-2.7,6-7.5,6C205,46.1,202.4,45,200.6,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M221.8,45.8V31.9h-5v-4h14.7v4h-5v13.9H221.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.9,45.8v-18h4.6v18H232.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M239.6,36.8c0-5.5,4.2-9.3,9.7-9.3c4.3,0,6.7,2.4,7.8,4.8l-4,1.9c-0.6-1.4-2.1-2.6-3.8-2.6 c-2.9,0-5,2.2-5,5.2c0,2.9,2.1,5.2,5,5.2c1.7,0,3.3-1.2,3.8-2.6l4,1.9c-1.2,2.3-3.5,4.8-7.8,4.8C243.8,46.1,239.6,42.4,239.6,36.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.9,45.8v-18h13.2v4h-8.5v2.8h8.3v4h-8.3v3h8.5v4H258.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M270.5,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C269.4,3.4,269.9,2.9,270.5,2.9L270.5,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.3,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C272.3,3.4,272.8,2.9,273.3,2.9 L273.3,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C267.9,0.5,268.4,0,269,0L269,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M271.8,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C270.8,0.5,271.2,0,271.8,0 L271.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274.7,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C273.6,0.5,274.1,0,274.7,0 L274.7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.5,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C276.4,0.5,276.9,0,277.5,0 L277.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.3,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C279.3,0.5,279.8,0,280.3,0 L280.3,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.2,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C282.1,0.5,282.6,0,283.2,0 L283.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276.2,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C275.1,3.4,275.6,2.9,276.2,2.9L276.2,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.1,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1C278.5,5,278,4.6,278,4C278,3.4,278.5,2.9,279.1,2.9 L279.1,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.9,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C280.8,3.4,281.3,2.9,281.9,2.9 L281.9,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.8,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C283.7,3.4,284.2,2.9,284.8,2.9 L284.8,2.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.2,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C271.2,6.3,271.6,5.8,272.2,5.8L272.2,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.1,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1S274,7.5,274,6.9C274,6.3,274.5,5.8,275.1,5.8 L275.1,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.9,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C276.9,6.3,277.4,5.8,277.9,5.8L277.9,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.8,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C279.7,6.3,280.2,5.8,280.8,5.8L280.8,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.6,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C282.6,6.3,283,5.8,283.6,5.8 L283.6,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.5,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C285.4,6.3,285.9,5.8,286.5,5.8 L286.5,5.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274.2,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C273.2,9.3,273.7,8.8,274.2,8.8L274.2,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.1,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C276,9.3,276.5,8.8,277.1,8.8 L277.1,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.9,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C278.9,9.3,279.4,8.8,279.9,8.8L279.9,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.8,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C281.7,9.3,282.2,8.8,282.8,8.8L282.8,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.6,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C284.6,9.3,285,8.8,285.6,8.8 L285.6,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.5,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C287.4,9.3,287.9,8.8,288.5,8.8 L288.5,8.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C275,12.2,275.5,11.7,276,11.7L276,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.9,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C277.8,12.2,278.3,11.7,278.9,11.7L278.9,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.8,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C280.7,12.2,281.2,11.7,281.8,11.7L281.8,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.6,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C283.5,12.2,284,11.7,284.6,11.7L284.6,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.4,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C286.4,12.2,286.8,11.7,287.4,11.7L287.4,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.3,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C289.2,12.2,289.7,11.7,290.3,11.7L290.3,11.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C277,15.1,277.5,14.7,278,14.7 L278,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.9,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C279.8,15.1,280.3,14.7,280.9,14.7 L280.9,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.8,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C282.7,15.1,283.2,14.7,283.8,14.7L283.8,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.6,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C285.5,15.1,286,14.7,286.6,14.7L286.6,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.4,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C288.4,15.1,288.8,14.7,289.4,14.7 L289.4,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.3,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C291.2,15.1,291.7,14.7,292.3,14.7 L292.3,14.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.9,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C278.8,18.1,279.3,17.6,279.9,17.6L279.9,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.8,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C281.7,18.1,282.2,17.6,282.8,17.6L282.8,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.6,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C284.6,18.1,285,17.6,285.6,17.6L285.6,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.5,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C287.4,18.1,287.9,17.6,288.5,17.6L288.5,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.3,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C290.2,18.1,290.7,17.6,291.3,17.6L291.3,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.2,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C293.1,18.1,293.6,17.6,294.2,17.6L294.2,17.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C280.9,21,281.4,20.5,282,20.5 L282,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.8,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C283.8,21,284.2,20.5,284.8,20.5 L284.8,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.7,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C286.6,21,287.1,20.5,287.7,20.5L287.7,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.5,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C289.5,21,289.9,20.5,290.5,20.5L290.5,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.4,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C292.3,21,292.8,20.5,293.4,20.5L293.4,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.3,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C295.2,21,295.7,20.5,296.3,20.5 L296.3,20.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.8,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C282.7,24,283.2,23.5,283.8,23.5L283.8,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.6,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C285.6,24,286,23.5,286.6,23.5 L286.6,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.5,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C288.4,24,288.9,23.5,289.5,23.5L289.5,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.3,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C291.3,24,291.7,23.5,292.3,23.5L292.3,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.2,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C294.1,24,294.6,23.5,295.2,23.5 L295.2,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.1,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C297,24,297.5,23.5,298.1,23.5 L298.1,23.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.7,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C284.6,27,285.1,26.5,285.7,26.5L285.7,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.5,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C287.4,27,287.9,26.5,288.5,26.5 L288.5,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.4,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C290.3,27,290.8,26.5,291.4,26.5L291.4,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.2,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C293.1,27,293.6,26.5,294.2,26.5L294.2,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.1,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C296,27,296.5,26.5,297.1,26.5 L297.1,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.9,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C298.9,27,299.3,26.5,299.9,26.5L299.9,26.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.7,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C286.7,29.9,287.1,29.4,287.7,29.4L287.7,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.6,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C289.5,29.9,290,29.4,290.6,29.4 L290.6,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.4,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C292.4,29.9,292.8,29.4,293.4,29.4L293.4,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.3,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C295.2,29.9,295.7,29.4,296.3,29.4L296.3,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.1,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C298.1,29.9,298.5,29.4,299.1,29.4 L299.1,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C300.9,29.9,301.4,29.4,302,29.4 L302,29.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.5,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C288.5,32.8,288.9,32.4,289.5,32.4L289.5,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.4,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C291.3,32.8,291.8,32.4,292.4,32.4L292.4,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.2,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C294.2,32.8,294.6,32.4,295.2,32.4L295.2,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.1,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C297,32.8,297.5,32.4,298.1,32.4L298.1,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.9,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C299.9,32.8,300.3,32.4,300.9,32.4L300.9,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.8,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C302.7,32.8,303.2,32.4,303.8,32.4L303.8,32.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.3,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C290.3,35.8,290.7,35.3,291.3,35.3L291.3,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.2,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C293.1,35.8,293.6,35.3,294.2,35.3L294.2,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C296,35.8,296.5,35.3,297,35.3L297,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.9,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C298.8,35.8,299.3,35.3,299.9,35.3L299.9,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302.7,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C301.7,35.8,302.1,35.3,302.7,35.3L302.7,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305.6,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C304.5,35.8,305,35.3,305.6,35.3 L305.6,35.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.3,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C289.2,38.7,289.7,38.2,290.3,38.2L290.3,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.1,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C292,38.7,292.5,38.2,293.1,38.2 L293.1,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C294.9,38.7,295.4,38.2,296,38.2L296,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.8,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C297.7,38.7,298.2,38.2,298.8,38.2L298.8,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M301.7,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C300.6,38.7,301.1,38.2,301.7,38.2 L301.7,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304.5,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C303.5,38.7,303.9,38.2,304.5,38.2 L304.5,38.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.3,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C287.3,41.6,287.7,41.2,288.3,41.2L288.3,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.2,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C290.1,41.6,290.6,41.2,291.2,41.2L291.2,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C293,41.6,293.4,41.2,294,41.2L294,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.9,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C295.8,41.6,296.3,41.2,296.9,41.2L296.9,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.7,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C298.7,41.6,299.1,41.2,299.7,41.2L299.7,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302.6,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C301.5,41.6,302,41.2,302.6,41.2 L302.6,41.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.4,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C285.3,44.6,285.8,44.1,286.4,44.1L286.4,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.2,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C288.2,44.6,288.6,44.1,289.2,44.1 L289.2,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.1,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C291,44.6,291.5,44.1,292.1,44.1L292.1,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.9,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C293.9,44.6,294.4,44.1,294.9,44.1L294.9,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.8,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C296.7,44.6,297.2,44.1,297.8,44.1 L297.8,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M300.7,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C299.6,44.6,300.1,44.1,300.7,44.1 L300.7,44.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.5,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C283.5,47.5,283.9,47,284.5,47L284.5,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.4,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C286.3,47.5,286.8,47,287.4,47 L287.4,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.2,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C289.2,47.5,289.6,47,290.2,47L290.2,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.1,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C292,47.5,292.5,47,293.1,47 L293.1,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M295.9,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C294.8,47.5,295.3,47,295.9,47 L295.9,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.8,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C297.7,47.5,298.2,47,298.8,47 L298.8,47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.6,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C281.5,50.5,282,50,282.6,50 L282.6,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.4,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C284.4,50.5,284.8,50,285.4,50 L285.4,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.3,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C287.2,50.5,287.7,50,288.3,50 L288.3,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.1,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C290.1,50.5,290.5,50,291.1,50 L291.1,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C292.9,50.5,293.4,50,294,50L294,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296.9,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C295.8,50.5,296.3,50,296.9,50 L296.9,50z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.7,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C279.6,53.4,280.1,52.9,280.7,52.9L280.7,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.5,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C282.4,53.4,282.9,52.9,283.5,52.9L283.5,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.4,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C285.3,53.4,285.8,52.9,286.4,52.9L286.4,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.2,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C288.1,53.4,288.6,52.9,289.2,52.9L289.2,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1S291,54.6,291,54C291,53.4,291.5,52.9,292,52.9 L292,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M294.9,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C293.8,53.4,294.3,52.9,294.9,52.9L294.9,52.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.8,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C277.7,56.3,278.2,55.9,278.8,55.9L278.8,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.6,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C280.6,56.3,281,55.9,281.6,55.9 L281.6,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.5,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C283.4,56.3,283.9,55.9,284.5,55.9L284.5,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.3,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C286.3,56.3,286.7,55.9,287.3,55.9L287.3,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290.2,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C289.1,56.3,289.6,55.9,290.2,55.9 L290.2,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C292,56.3,292.5,55.9,293,55.9 L293,55.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276.9,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C275.8,59.3,276.3,58.8,276.9,58.8L276.9,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.8,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C278.7,59.3,279.2,58.8,279.8,58.8L279.8,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.6,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C281.5,59.3,282,58.8,282.6,58.8L282.6,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.5,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C284.4,59.3,284.9,58.8,285.5,58.8L285.5,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.3,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C287.2,59.3,287.7,58.8,288.3,58.8L288.3,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.2,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C290.1,59.3,290.6,58.8,291.2,58.8L291.2,58.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C273.9,62.3,274.4,61.8,275,61.8L275,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.8,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C276.7,62.3,277.2,61.8,277.8,61.8L277.8,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.7,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C279.6,62.3,280.1,61.8,280.7,61.8L280.7,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.5,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C282.5,62.3,282.9,61.8,283.5,61.8L283.5,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M286.4,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C285.3,62.3,285.8,61.8,286.4,61.8L286.4,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M289.2,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C288.2,62.3,288.6,61.8,289.2,61.8L289.2,61.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C272,65.2,272.4,64.7,273,64.7 L273,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M275.9,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C274.8,65.2,275.3,64.7,275.9,64.7 L275.9,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.7,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C277.7,65.2,278.2,64.7,278.7,64.7L278.7,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.6,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C280.5,65.2,281,64.7,281.6,64.7L281.6,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M284.4,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C283.4,65.2,283.8,64.7,284.4,64.7 L284.4,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.3,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C286.2,65.2,286.7,64.7,287.3,64.7 L287.3,64.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M271.1,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C270,68.2,270.5,67.7,271.1,67.7L271.1,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M273.9,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C272.9,68.2,273.4,67.7,273.9,67.7L273.9,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276.8,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C275.7,68.2,276.2,67.7,276.8,67.7L276.8,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M279.7,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C278.6,68.2,279.1,67.7,279.7,67.7L279.7,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M282.5,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C281.4,68.2,281.9,67.7,282.5,67.7L282.5,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285.4,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C284.3,68.2,284.8,67.7,285.4,67.7L285.4,67.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269.2,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C268.2,71.1,268.6,70.6,269.2,70.6L269.2,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.1,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C271,71.1,271.5,70.6,272.1,70.6 L272.1,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M274.9,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C273.9,71.1,274.3,70.6,274.9,70.6L274.9,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.8,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C276.7,71.1,277.2,70.6,277.8,70.6L277.8,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M280.6,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C279.6,71.1,280,70.6,280.6,70.6 L280.6,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M283.5,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C282.4,71.1,282.9,70.6,283.5,70.6L283.5,70.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M288.6,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C287.5,3.4,288,2.9,288.6,2.9 L288.6,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M291.4,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C290.3,3.4,290.8,2.9,291.4,2.9L291.4,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.2,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C293.2,3.4,293.6,2.9,294.2,2.9L294.2,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M297.1,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1C296.5,5,296,4.6,296,4C296,3.4,296.5,2.9,297.1,2.9 L297.1,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.9,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C298.9,3.4,299.3,2.9,299.9,2.9L299.9,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.9,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C288.8,0.5,289.3,0,289.9,0 L289.9,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M292.7,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C291.7,0.5,292.1,0,292.7,0 L292.7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295.6,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C294.5,0.5,295,0,295.6,0 L295.6,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M298.4,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C297.3,0.5,297.8,0,298.4,0 L298.4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287.1,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C286,0.5,286.5,0,287.1,0 L287.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.2,0c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C300.2,0.5,300.7,0,301.2,0 L301.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M302.8,2.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C301.7,3.4,302.2,2.9,302.8,2.9L302.8,2.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M290.3,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C289.2,6.3,289.7,5.8,290.3,5.8L290.3,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293.1,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C292.1,6.3,292.5,5.8,293.1,5.8L293.1,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M296,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C294.9,6.3,295.4,5.8,296,5.8 L296,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M298.8,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C297.7,6.3,298.2,5.8,298.8,5.8L298.8,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.7,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C300.6,6.3,301.1,5.8,301.7,5.8 L301.7,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M304.5,5.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C303.5,6.3,303.9,5.8,304.5,5.8L304.5,5.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M292.3,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C291.2,9.3,291.7,8.8,292.3,8.8L292.3,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295.1,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C294.1,9.3,294.5,8.8,295.1,8.8L295.1,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M298,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C296.9,9.3,297.4,8.8,298,8.8 L298,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.8,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C299.7,9.3,300.2,8.8,300.8,8.8L300.8,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.7,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C302.6,9.3,303.1,8.8,303.7,8.8 L303.7,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.5,8.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C305.5,9.3,305.9,8.8,306.5,8.8L306.5,8.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.1,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C293,12.2,293.5,11.7,294.1,11.7L294.1,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M296.9,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C295.9,12.2,296.3,11.7,296.9,11.7L296.9,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.8,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C298.7,12.2,299.2,11.7,299.8,11.7L299.8,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M302.6,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C301.6,12.2,302,11.7,302.6,11.7L302.6,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.5,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C304.4,12.2,304.9,11.7,305.5,11.7L305.5,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.3,11.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C307.3,12.2,307.7,11.7,308.3,11.7L308.3,11.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M296.1,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C295,15.1,295.5,14.7,296.1,14.7L296.1,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M298.9,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C297.9,15.1,298.4,14.7,298.9,14.7L298.9,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.8,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C300.7,15.1,301.2,14.7,301.8,14.7L301.8,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M304.6,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C303.6,15.1,304,14.7,304.6,14.7L304.6,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.5,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C306.4,15.1,306.9,14.7,307.5,14.7 L307.5,14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.3,14.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C309.3,15.1,309.7,14.7,310.3,14.7L310.3,14.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M298,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C296.9,18.1,297.4,17.6,298,17.6L298,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.8,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C299.7,18.1,300.2,17.6,300.8,17.6L300.8,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.7,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C302.6,18.1,303.1,17.6,303.7,17.6L303.7,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.5,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C305.4,18.1,305.9,17.6,306.5,17.6L306.5,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.3,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C308.3,18.1,308.7,17.6,309.3,17.6L309.3,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.2,17.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C311.1,18.1,311.6,17.6,312.2,17.6L312.2,17.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C299,21,299.4,20.5,300,20.5 L300,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M302.9,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C301.8,21,302.3,20.5,302.9,20.5L302.9,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.7,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C304.7,21,305.1,20.5,305.7,20.5L305.7,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.6,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C307.5,21,308,20.5,308.6,20.5L308.6,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.4,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C310.3,21,310.8,20.5,311.4,20.5 L311.4,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.3,20.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C313.2,21,313.7,20.5,314.3,20.5L314.3,20.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.8,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C300.8,24,301.3,23.5,301.8,23.5L301.8,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M304.7,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C303.6,24,304.1,23.5,304.7,23.5L304.7,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.5,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C306.5,24,306.9,23.5,307.5,23.5L307.5,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.4,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C309.3,24,309.8,23.5,310.4,23.5L310.4,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M313.2,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C312.1,24,312.6,23.5,313.2,23.5 L313.2,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.1,23.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C315,24,315.5,23.5,316.1,23.5L316.1,23.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.7,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C302.6,27,303.1,26.5,303.7,26.5L303.7,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.6,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C305.5,27,306,26.5,306.6,26.5L306.6,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.4,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C308.3,27,308.8,26.5,309.4,26.5L309.4,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.2,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C311.2,27,311.6,26.5,312.2,26.5L312.2,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M315.1,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C314,27,314.5,26.5,315.1,26.5 L315.1,26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.9,26.5c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C316.9,27,317.4,26.5,317.9,26.5L317.9,26.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.8,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C304.7,29.9,305.2,29.4,305.8,29.4L305.8,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.6,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C307.6,29.9,308,29.4,308.6,29.4L308.6,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.5,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C310.4,29.9,310.9,29.4,311.5,29.4L311.5,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.3,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C313.2,29.9,313.7,29.4,314.3,29.4L314.3,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.2,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C316.1,29.9,316.6,29.4,317.2,29.4 L317.2,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M320,29.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C318.9,29.9,319.4,29.4,320,29.4L320,29.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.6,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C306.5,32.8,307,32.4,307.6,32.4L307.6,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.4,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C309.4,32.8,309.8,32.4,310.4,32.4L310.4,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M313.3,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C312.2,32.8,312.7,32.4,313.3,32.4L313.3,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.1,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C315,32.8,315.5,32.4,316.1,32.4L316.1,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M319,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C317.9,32.8,318.4,32.4,319,32.4 L319,32.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M321.8,32.4c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C320.7,32.8,321.2,32.4,321.8,32.4L321.8,32.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.4,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C308.3,35.8,308.8,35.3,309.4,35.3L309.4,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.2,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C311.2,35.8,311.6,35.3,312.2,35.3L312.2,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M315.1,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C314,35.8,314.5,35.3,315.1,35.3L315.1,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.9,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C316.8,35.8,317.3,35.3,317.9,35.3L317.9,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M320.8,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C319.7,35.8,320.2,35.3,320.8,35.3L320.8,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M323.6,35.3c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C322.6,35.8,323,35.3,323.6,35.3L323.6,35.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.3,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C307.2,38.7,307.7,38.2,308.3,38.2L308.3,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.2,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C310.1,38.7,310.6,38.2,311.2,38.2L311.2,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C312.9,38.7,313.4,38.2,314,38.2L314,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.8,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C315.8,38.7,316.3,38.2,316.8,38.2L316.8,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M319.7,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C318.6,38.7,319.1,38.2,319.7,38.2 L319.7,38.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M322.6,38.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C321.5,38.7,322,38.2,322.6,38.2L322.6,38.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.4,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C305.3,41.6,305.8,41.2,306.4,41.2L306.4,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.2,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C308.2,41.6,308.6,41.2,309.2,41.2L309.2,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.1,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C311,41.6,311.5,41.2,312.1,41.2L312.1,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.9,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C313.8,41.6,314.3,41.2,314.9,41.2L314.9,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.8,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C316.7,41.6,317.2,41.2,317.8,41.2L317.8,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M320.6,41.2c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C319.5,41.6,320,41.2,320.6,41.2L320.6,41.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M304.4,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C303.4,44.6,303.9,44.1,304.4,44.1L304.4,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.3,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C306.2,44.6,306.7,44.1,307.3,44.1L307.3,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.1,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C309.1,44.6,309.5,44.1,310.1,44.1L310.1,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M313,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C311.9,44.6,312.4,44.1,313,44.1L313,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M315.8,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C314.7,44.6,315.2,44.1,315.8,44.1 L315.8,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M318.7,44.1c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C317.6,44.6,318.1,44.1,318.7,44.1L318.7,44.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M302.6,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C301.5,47.5,302,47,302.6,47 L302.6,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.4,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C304.3,47.5,304.8,47,305.4,47L305.4,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.3,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C307.2,47.5,307.7,47,308.3,47L308.3,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.1,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C310,47.5,310.5,47,311.1,47 L311.1,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M313.9,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C312.9,47.5,313.4,47,313.9,47 L313.9,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.8,47c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C315.7,47.5,316.2,47,316.8,47L316.8,47z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.6,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C299.6,50.5,300,50,300.6,50 L300.6,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.5,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C302.4,50.5,302.9,50,303.5,50 L303.5,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.3,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C305.3,50.5,305.7,50,306.3,50 L306.3,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.2,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C308.1,50.5,308.6,50,309.2,50 L309.2,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C310.9,50.5,311.4,50,312,50L312,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.9,50c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C313.8,50.5,314.3,50,314.9,50 L314.9,50z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M298.7,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C297.6,53.4,298.1,52.9,298.7,52.9L298.7,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.5,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C300.5,53.4,301,52.9,301.5,52.9L301.5,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M304.4,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C303.3,53.4,303.8,52.9,304.4,52.9L304.4,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.2,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C306.2,53.4,306.6,52.9,307.2,52.9L307.2,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.1,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1S309,54.6,309,54C309,53.4,309.5,52.9,310.1,52.9 L310.1,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.9,52.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C311.9,53.4,312.3,52.9,312.9,52.9L312.9,52.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M296.8,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C295.8,56.3,296.2,55.9,296.8,55.9L296.8,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.7,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C298.6,56.3,299.1,55.9,299.7,55.9L299.7,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M302.5,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C301.4,56.3,301.9,55.9,302.5,55.9L302.5,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.4,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C304.3,56.3,304.8,55.9,305.4,55.9L305.4,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.2,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C307.1,56.3,307.6,55.9,308.2,55.9 L308.2,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M311.1,55.9c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C310,56.3,310.5,55.9,311.1,55.9L311.1,55.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C293.9,59.3,294.4,58.8,295,58.8L295,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M297.8,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C296.7,59.3,297.2,58.8,297.8,58.8L297.8,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.6,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C299.6,59.3,300.1,58.8,300.6,58.8L300.6,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.5,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C302.4,59.3,302.9,58.8,303.5,58.8L303.5,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.3,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C305.3,59.3,305.7,58.8,306.3,58.8L306.3,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.2,58.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C308.1,59.3,308.6,58.8,309.2,58.8L309.2,58.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C292,62.3,292.4,61.8,293,61.8L293,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295.9,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C294.8,62.3,295.3,61.8,295.9,61.8L295.9,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M298.7,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C297.6,62.3,298.1,61.8,298.7,61.8L298.7,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.6,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C300.5,62.3,301,61.8,301.6,61.8L301.6,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M304.4,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C303.3,62.3,303.8,61.8,304.4,61.8L304.4,61.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.3,61.8c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C306.2,62.3,306.7,61.8,307.3,61.8L307.3,61.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M291.1,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C290,65.2,290.5,64.7,291.1,64.7L291.1,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293.9,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C292.9,65.2,293.3,64.7,293.9,64.7L293.9,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M296.8,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C295.7,65.2,296.2,64.7,296.8,64.7L296.8,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M299.6,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C298.5,65.2,299,64.7,299.6,64.7L299.6,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M302.5,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1C301.4,65.2,301.9,64.7,302.5,64.7 L302.5,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.3,64.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C304.3,65.2,304.7,64.7,305.3,64.7L305.3,64.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289.2,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C288.1,68.2,288.6,67.7,289.2,67.7L289.2,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M292,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C290.9,68.2,291.4,67.7,292,67.7L292,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M294.8,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C293.8,68.2,294.2,67.7,294.8,67.7L294.8,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M297.7,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C296.6,68.2,297.1,67.7,297.7,67.7L297.7,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M300.5,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C299.5,68.2,299.9,67.7,300.5,67.7L300.5,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.4,67.7c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C302.3,68.2,302.8,67.7,303.4,67.7L303.4,67.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M287.3,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C286.2,71.1,286.7,70.6,287.3,70.6L287.3,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M290.1,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C289.1,71.1,289.5,70.6,290.1,70.6L290.1,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C291.9,71.1,292.4,70.6,293,70.6L293,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M295.8,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C294.7,71.1,295.2,70.6,295.8,70.6L295.8,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M298.7,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1 C297.6,71.1,298.1,70.6,298.7,70.6L298.7,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M301.5,70.6c0.6,0,1.1,0.5,1.1,1.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1 C300.4,71.1,300.9,70.6,301.5,70.6L301.5,70.6z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollab13);
export default __webpack_public_path__ + "static/media/collab-13.7138ad93cad55146e8d06c97c3c0b9c4.svg";
export { ForwardRef as ReactComponent };